
import { useEffect, useState } from "react"
import url from "../api/url"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"
import Card from 'react-bootstrap/Card';
import { archivos_necesarios } from "../data/datos";


function useListadoDeArchivos() {

    // variables
    // eslint-disable-next-line
    const [cargando, setCargando] = useState(false)
    const [cargandoArchivos, setCargandoArchivos] = useState(false)
    const [cargandoArchivos2, setCargandoArchivos2] = useState(false)
    const { URL, SERVIDOR } = url()
    const [errorCarpetas, setErrorCarpetas] = useState(false)
    const { actualizarJsonArchivos, carpeta, actualizarListaArchivos, actualizarListaArchivosOtros } = useEmpleadoStore()




    // funciones
    function obtenerEstructuraDirectorio() {

        setCargando(true)
        var fdata = new FormData()
        fdata.append("funcion", "obtenerEstructuraDirectorio")

        fetch( URL, {
            body: fdata,
            method: 'post'
        })
        .then( res => res.json() )
        .then( function (d) {
            actualizarJsonArchivos( d.datos )
        })
        .catch( function(error) {
            // alert("Ocurrió un error al mostrar las carpetas")
            setErrorCarpetas(true)
        })
        .finally( e => setCargando(false))

    }

    function traerArchivosDeCarpeta() {
        var fd = new FormData()
        fd.append("funcion", "obtenerArchivosTitulado")
        fd.append("correo", carpeta)
        setCargandoArchivos(true)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            actualizarListaArchivos( e )
        })
        .catch( a => {
        })
        .finally( e => {
            setCargandoArchivos(false)
        })
    }


    function traerDocumentosPersona() {
        var fd = new FormData()
        fd.append("funcion", "traerDocumentosPersona")
        fd.append("correo", carpeta)
        setCargandoArchivos2(true)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            actualizarListaArchivosOtros( e )
        })
        .catch( a => {
        })
        .finally( e => {
            setCargandoArchivos2(false)
        })
    }

    function url_archivos(nombre_archivos, carpeta) {

        // var correo_nuevo = objLogueado.email.split('@')[0];

        return `${SERVIDOR}/archivos/${carpeta}/${nombre_archivos}`

    }

    function EnlaceTitulo( {es_titulado, archivo, texto, carpeta} ) {

        if (es_titulado && archivo ) {
            return <Card.Link href={ url_archivos( archivo, carpeta ) } target="_blank">{texto}</Card.Link>
        }

        if ( es_titulado && archivo == null ) {
            return <span>{texto} pendiente</span>
        }

        if ( es_titulado && [null, '', undefined].includes(archivo) ) {
            return <span>{texto} pendiente</span>
        }

        return <span>{texto} pendiente</span>

    }

    function tipoArchivo( nombre ) {
        // eslint-disable-next-line
        var a = archivos_necesarios.find( e => e.nombre == nombre )
        return a.descripcion
    }


    // useEffect
    useEffect(() => {
        obtenerEstructuraDirectorio()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (carpeta != null) {
            traerArchivosDeCarpeta()
            traerDocumentosPersona()
        } else {
            actualizarListaArchivos([])
            actualizarListaArchivosOtros([])
        }
        // eslint-disable-next-line
    }, [ carpeta ])



    return {
        errorCarpetas, EnlaceTitulo, cargandoArchivos, tipoArchivo, cargandoArchivos2
    }
}

export default useListadoDeArchivos
